import React, { useState, useEffect } from 'react';
import {
	Container,
	Box,
	Grid,
	useTheme,
	useMediaQuery,
	Button,
} from '@mui/material';
import Footer from '../components/resuableComponents/Footer';
import Login from '../components/resuableComponents/Login';
import { Divider } from 'antd';
import { fetchCityDispatch, fetchHotel } from '../reducers/HomeReducer';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import Carousels from '../components/resuableComponents/Carousels';
import { fetchBusCityDispatch } from '../reducers/BusReducer';
import hotelIcon from '../assets/images/hotelIcon.svg';
import mealIcon from '../assets/images/mealIcon.svg';
import transport from '../assets/images/transport.svg';
import tour from '../assets/images/tour.svg';
import itinerary from '../assets/images/itinerary.svg';
import flight from '../assets/images/flight.svg';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import SliderPage from '../components/resuableComponents/SliderPage';
import Gallery from '../components/resuableComponents/Gallery';
import MNavbar from '../components/resuableComponents/Navbar/MobileNav/MNavbar';
import { useSelect } from '@mui/base';
import {
	agentbookinghistoryDispatch,
	agenttransactionhistoryDispatch,
	walletBalanceAgentDispatch,
} from '../reducers/UserReducer';
const popularFlight = [
	{
		name: 'Indigo Airlines',
		image: 'https://images.ixigo.com/img/common-resources/airline-new/6E.png',
	},
	{
		name: 'Air India',
		image: 'https://images.ixigo.com/img/common-resources/airline-new/AI.png',
	},
	{
		name: 'Air India Express',
		image: 'https://images.ixigo.com/img/common-resources/airline-new/IX.png',
	},
	{
		name: 'Air Asia India',
		image: 'https://images.ixigo.com/img/common-resources/airline-new/I5.png',
	},
	{
		name: 'Akasa Air',
		image: 'https://images.ixigo.com/img/common-resources/airline-new/QP.png',
	},
	{
		name: 'Vistara Airline',
		image: 'https://images.ixigo.com/img/common-resources/airline-new/UK.png',
	},
	{
		name: 'SpiceJet',
		image: 'https://images.ixigo.com/img/common-resources/airline-new/SG.png',
	},
];
const popular = [
	{
		image:
			'https://www.easemytrip.com/images/desk-img/hol-icon/andaman-new.png',
		name: 'Andaman',
	},
	{
		image:
			'https://www.easemytrip.com/images/desk-img/hol-icon/kashmir-new.svg',
		name: 'Kashmir',
	},
	{
		image: 'https://www.easemytrip.com/images/desk-img/hol-icon/jaipur.svg',
		name: 'Jaipur',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image: 'https://www.easemytrip.com/images/desk-img/hol-icon/bangalore.svg',
		name: 'Bangaluru',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image: 'https://www.easemytrip.com/images/desk-img/hol-icon/paris.svg',
		name: 'Paris',
	},
	{
		image: 'https://www.easemytrip.com/images/desk-img/hol-icon/leh.svg',
		name: 'Bali',
	},
	{
		image:
			'https://www.easemytrip.com/images/desk-img/hol-icon/bali-indonesia.svg',
		name: 'Dubai',
	},
	{
		image: 'https://www.easemytrip.com/images/desk-img/hol-icon/dubai.svg',
		name: 'Dubai',
	},
	{
		image: 'https://www.easemytrip.com/images/desk-img/hol-icon/kerala.svg',
		name: 'kerala',
	},
];
const popularDes = [
	{
		image: 'https://www.easemytrip.com/images/desk-img/hol-icon/london.svg',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image: 'https://www.easemytrip.com/images/desk-img/hol-icon/london.svg',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image: 'https://www.easemytrip.com/images/desk-img/hol-icon/london.svg',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image: 'https://www.easemytrip.com/images/desk-img/hol-icon/london.svg',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image: 'https://www.easemytrip.com/images/desk-img/hol-icon/london.svg',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image: 'https://www.easemytrip.com/images/desk-img/hol-icon/london.svg',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image: 'https://www.easemytrip.com/images/desk-img/hol-icon/london.svg',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image: 'https://www.easemytrip.com/images/desk-img/hol-icon/london.svg',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	{
		image: 'https://www.easemytrip.com/images/desk-img/hol-icon/london.svg',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
	// $$)I[aCE)8Xz
	{
		image: 'https://www.easemytrip.com/images/desk-img/hol-icon/london.svg',
		name: 'Mumbai Flights',
		to: ['Goa', 'Delhi', 'Banglore', 'Ahmedabad'],
	},
];
const slider = [
	'https://images.unsplash.com/photo-1501594907352-04cda38ebc29?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1932&q=80',
	'https://images.unsplash.com/photo-1475189778702-5ec9941484ae?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2071&q=80',
	'https://images.pexels.com/photos/18201084/pexels-photo-18201084/free-photo-of-sky-tower-over-buildings-in-auckland-at-sunset.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
	'https://wallpapercave.com/wp/wp9388467.jpg',
];
const tours = [
	{
		image: hotelIcon,
		title: 'Accommodation',
		desc: 'Comfortable & convenient hotels cherry picked by our hotel management team',
	},
	{
		image: mealIcon,
		title: 'All meals',
		desc: "Eat to your heart's content Breakfast. Lunch. Dinner.",
	},
	{
		image: transport,
		title: 'On-tour transport',
		desc: 'Our itineraries include all rail, sea and road transport as part of the itinerary so you can enjoy tension free',
	},
	{
		image: tour,
		title: 'Tour managers',
		desc: 'We have an exclusive team of 350 tour managers specialising in India and World tours',
	},
	{
		image: itinerary,
		title: 'Best value itinerary',
		desc: 'Our dedicated product & destination research team spends hours curating the best value for money itineraries',
	},
	{
		image: flight,
		title: 'To and from airfare',
		desc: 'MusafirBazar tours are inclusive of airfare from many hubs within India unless you pick the joining-leaving option',
	},
];
const LandingPage = () => {
	const dispatch = useDispatch();
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	const { agentlogin } = useSelector((state) => state.user);
	const notify = () => toast.success('Login Sucessfull !');
	const errorF = () => toast.error('Login Failed !');
	useEffect(() => {
		window.scrollTo(0, 0);
		let form = {};
		dispatch(fetchBusCityDispatch(form));
		dispatch(fetchHotel(form));
		let cityData = {
			keywords: 'b',
			limits: 8,
		};
		dispatch(fetchCityDispatch(cityData));
		if (agentlogin?.status === 200) {
			dispatch(
				agentbookinghistoryDispatch(
					agentlogin &&
						agentlogin.result &&
						agentlogin.result.result &&
						agentlogin.result.result.id
				)
			);
			dispatch(
				agenttransactionhistoryDispatch(
					agentlogin &&
						agentlogin.result &&
						agentlogin.result.result &&
						agentlogin.result.result.id
				)
			);
			dispatch(
				walletBalanceAgentDispatch(
					agentlogin &&
						agentlogin.result &&
						agentlogin.result.result &&
						agentlogin.result.result.email,
					agentlogin &&
						agentlogin.result &&
						agentlogin.result.result &&
						agentlogin.result.result.id
				)
			);
		}
	}, []);

	return (
		<div>
			<header className='App-header'>
				<Navbar />
				<MNavbar />
				<SliderPage images={slider} />
				<Box style={{ marginTop: 20 }} className='one'>
					<h1
						style={{
							textAlign: 'center',
							fontWeight: '500',
							fontSize: matches ? 20 : 42,
							position: 'relative',
						}}>
						Popular Destination
					</h1>
					<Container style={{ marginTop: 20 }}>
						<Carousels />
					</Container>
				</Box>
				<Box className='one'>
					<h1
						style={{
							textAlign: 'center',
							fontWeight: '500',
							fontSize: matches ? 20 : 42,
							position: 'relative',
						}}>
						Best Flight Deals Of The Day
					</h1>
				</Box>
				<Container className='m'>
					<Box style={{ padding: 20 }}>
						<Grid
							container
							spacing={4}
							style={{ marginTop: 30, marginBottom: 30 }}>
							{popularDes.map((i) => {
								return (
									<Grid item xs={12} lg={4}>
										{' '}
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<img
												src={i.image}
												style={{ height: 45, width: 45, borderRadius: 25 }}
											/>
											<Box style={{ marginLeft: 10 }}>
												<span>{i.name}</span>
												<br />
												<span>To</span>:{' '}
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
													}}>
													{i.to[0]}
												</span>{' '}
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
														marginLeft: 5,
													}}>
													{i.to[1]}
												</span>
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
														marginLeft: 5,
													}}>
													{i.to[2]}
												</span>
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
														marginLeft: 5,
													}}>
													{i.to[3]}
												</span>
											</Box>
										</Box>
									</Grid>
								);
							})}
						</Grid>
					</Box>
				</Container>
				<Box className='one'>
					<h1
						style={{
							textAlign: 'center',
							fontWeight: '500',
							fontSize: matches ? 20 : 42,
							position: 'relative',
						}}>
						Top Destination
					</h1>
				</Box>

				<Gallery />
				<Box className='one'>
					<h1
						style={{
							textAlign: 'center',
							fontWeight: '500',
							fontSize: matches ? 20 : 42,
							marginTop: 20,
							position: 'relative',
						}}>
						Famous Tourist Attraction
					</h1>
				</Box>

				<Container className='m'>
					<Box style={{ padding: 20 }}>
						<Grid
							container
							spacing={4}
							style={{ marginTop: 30, marginBottom: 30 }}>
							{popular.map((i) => {
								return (
									<Grid item xs={12} lg={3}>
										{' '}
										<Box style={{ display: 'flex', justifyContent: 'center' }}>
											<img
												src={i.image}
												style={{
													height: 100,
													width: 100,
													borderRadius: 25,
													textAlign: 'center',
												}}
											/>

											{/* <Box style={{ marginLeft: 10 }}>
												<span>{i.name}</span>
												<br />
												<span>To</span>:{' '}
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
													}}>
													{i.to[0]}
												</span>{' '}
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
														marginLeft: 5,
													}}>
													{i.to[1]}
												</span>
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
														marginLeft: 5,
													}}>
													{i.to[2]}
												</span>
												<span
													style={{
														color: 'orange',
														fontSize: 14,
														fontWeight: 500,
														marginLeft: 5,
													}}>
													{i.to[3]}
												</span>
											</Box> */}
										</Box>
										<h2 style={{ textAlign: 'center' }}>{i.name}</h2>
									</Grid>
								);
							})}
						</Grid>
					</Box>
				</Container>
				<Container style={{ marginBottom: 40 }}>
					<h2
						style={{
							textAlign: 'center',
							fontWeight: 600,
							color: 'rgb(114, 28, 129)',
							fontSize: matches ? 22 : 26,
						}}>
						All inclusive tours, Chalo Bag Bharo Nikal Pado!
					</h2>
					<br />
					<br />
					<Grid container spacing={4}>
						{tours.map((r) => {
							return (
								<Grid item xs={12} lg={4}>
									<Box style={{ textAlign: 'center' }}>
										<img src={r.image} style={{ display: 'inline' }} />
										<h3
											style={{
												color: '#721c81',
											}}>
											{r.title}
										</h3>
										<span style={{ fontSize: 16 }}>{r.desc}</span>
									</Box>
								</Grid>
							);
						})}
					</Grid>
				</Container>
				<Box className='one'>
					<h1
						style={{
							textAlign: 'center',
							fontWeight: '500',
							fontSize: matches ? 20 : 42,
							marginTop: 20,
							position: 'relative',
						}}>
						Popular Domestic Airlines
					</h1>
				</Box>

				<Container className='m2'>
					<Box style={{ padding: 20 }}>
						<Grid container spacing={2} style={{ marginTop: 30 }}>
							{popularFlight.map((i) => {
								return (
									<Grid item xs={6} lg={2}>
										<Box>
											<img src={i.image} />
											<br />
											<p style={{ marginTop: 15, fontSize: 12 }}>{i.name}</p>
										</Box>
									</Grid>
								);
							})}
						</Grid>
					</Box>
				</Container>
				<Divider style={{ border: '1px solid lightgrey' }} />
				<Footer />
			</header>
			<Login notify={notify} errorF={errorF} />
			{/* <Button onClick={notify}>htttt</Button> */}
			<ToastContainer position='top-center' theme='colored' />
		</div>
	);
};

export default LandingPage;
